export default __webpack_public_path__ + "static/media/47-relaxeddoggo.a8f27bf3.jpg";